import { RoomManager } from "../../managers/RoomManager";
import { BananaSpine } from "./banana/BananaSpine";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { RoomScene } from "./RoomScene";
import { Translation } from "../../Translation";

export class WinnerPlayerLayer extends Phaser.GameObjects.Container {

    public banana: BananaSpine;

    private textContainer: Phaser.GameObjects.Container;
    private handText: Phaser.GameObjects.Text;
    private winnerText: Phaser.GameObjects.Text;
    private winnerPlayerText: Phaser.GameObjects.Text;
    private winnerImage: Phaser.GameObjects.Image;
    private cards: Phaser.GameObjects.Image[];

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT;

        this.scaleX = GameVars.scaleX;

        this.textContainer = new Phaser.GameObjects.Container(this.scene);
        this.add(this.textContainer);

        this.winnerImage = new Phaser.GameObjects.Image(this.scene, 0, -80, "texture_atlas_1", "name_big_demon.png");
        this.winnerImage.setOrigin(1, .5);
        this.textContainer.add(this.winnerImage);

        this.winnerText = new Phaser.GameObjects.Text(this.scene, 0, -80, Translation.getText("WINS_THE_HAND"), { fontFamily: "Oswald-Medium", fontSize: "40px", color: "#ffffff" });
        this.winnerText.setOrigin(0, .5);
        this.textContainer.add(this.winnerText);

        this.winnerPlayerText = new Phaser.GameObjects.Text(this.scene, 0, -80, Translation.getText("YOU_WIN_THE_HAND__"), { fontFamily: "Oswald-Medium", fontSize: "40px", color: "#ffffff" });
        this.winnerPlayerText.setOrigin(.5);
        this.textContainer.add(this.winnerPlayerText);

        this.handText = new Phaser.GameObjects.Text(this.scene, 0, -5, "", { fontFamily: "Oswald-Medium", fontSize: "30px", color: "#ffffff" });
        this.handText.setOrigin(0, 1);
        this.textContainer.add(this.handText);

        this.cards = [];

        for (let i = 0; i < 5; i++) {

            let card = new Phaser.GameObjects.Image(this.scene, 100 + i * 45, -30, "texture_atlas_2", "card-back.png");
            card.setScale(.45);
            this.textContainer.add(card);
            this.cards.push(card);
        }

        this.banana = new BananaSpine(this.scene);
        this.banana.y = -200;
        this.banana.x = 220;
        this.add(this.banana);

        this.visible = false;
    }

    public updateWinnerHand(texts: string[], winnersIds: string[], cards: any[]): void {

        for (let i = 0; i < winnersIds.length; i++) {

            this.scene.time.addEvent({
                delay: (1000 * i) / GameVars.gameSpeed, callback: () => {
                    if (winnersIds[i] === GameVars.playerId) {
                        this.winnerText.visible = false;
                        this.winnerPlayerText.visible = true;
                        this.winnerImage.visible = false;

                        if (winnersIds.length === 1) {
                            this.banana.visible = true;

                            this.banana.y = 0;

                            if (RoomManager.getPlayer(GameVars.playerId).payout >= 4000) {
                                this.banana.setAvatarState("victory3");
                            } else if (RoomManager.getPlayer(GameVars.playerId).payout >= 2000) {
                                this.banana.setAvatarState("victory2");
                            } else {
                                this.banana.setAvatarState("victory1");
                            }

                            this.scene.tweens.add({
                                targets: this.banana,
                                y: -200,
                                ease: Phaser.Math.Easing.Linear.Linear,
                                duration: 250 / GameVars.gameSpeed
                            });
                        } else {
                            this.banana.visible = false;
                        }

                    } else {
                        this.winnerText.visible = true;
                        this.winnerPlayerText.visible = false;
                        this.winnerImage.visible = true;
                        this.banana.visible = false;
                        this.winnerImage.setFrame("name_big_" + winnersIds[i] + ".png");
                    }

                    this.visible = true;

                    this.textContainer.visible = true;

                    this.handText.setText(texts[i].toUpperCase().replace(/_/g, " "));

                    let totalWidth = this.handText.width + 225;
                    this.handText.x = - totalWidth / 2;

                    let lengthCards = 0;

                    switch (texts[i]) {
                        case GameConstants.HIGH_CARD:
                            lengthCards = 1;
                            break;
                        case GameConstants.PAIR:
                            lengthCards = 2;
                            break;
                        case GameConstants.THREE_OF_A_KIND:
                            lengthCards = 3;
                            break;
                        case GameConstants.TWO_PAIR:
                        case GameConstants.FOUR_OF_A_KIND:
                            lengthCards = 4;
                            break;
                        default:
                            lengthCards = 5;
                            break;
                    }

                    for (let j = 0; j < 5; j++) {
                        this.cards[j].setFrame(GameVars.cardFrameName(cards[i][j].value + cards[i][j].suit) + ".png");
                        this.cards[j].x = this.handText.x + 40 + this.handText.width + j * 45;

                        if (j < lengthCards) {
                            this.cards[j].alpha = 1;
                        } else {
                            this.cards[j].alpha = .6;
                        }
                    }
                }, callbackScope: this
            });
        }
    }

    public removeWinnerHand(): void {
        this.scene.tweens.add({
            targets: this.banana,
            y: 0,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250 / GameVars.gameSpeed,
            onComplete: () => {
                this.visible = false;
                this.banana.visible = false;

                if (GameVars.gameOver) {
                    RoomScene.currentInstance.showLeave();
                }
            },
            onCompleteScope: this
        });
    }
}
